import React, { Component } from "react";

class About extends Component{
    render(){
        let title = 'About',
        description = 'Siamo Beatdata, pionieri dell\'innovazione tecnologica. Specializzati in sviluppo software, AI, integrazione aziendale e soluzioni blockchain, affrontiamo le sfide tecniche con passione. Offriamo servizi all\'avanguardia, guidando le imprese verso un futuro digitale in continua evoluzione. Siamo il tuo partner di fiducia.';
        return(
            <React.Fragment>
                <div className="about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">

                            <div className="col-lg-5 col-md-12">
                                <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/about-1.jpg" alt="About Images"/>
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <h2 className="title">{title}</h2>
                                        <p className="description">{description}</p>
                                    </div>
                                    <div className="row mt--30 mt_sm--10">
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">La Nostra Storia</h3>
                                                <p>In Beatdata, ci impegniamo a fornire soluzioni software all'avanguardia e un servizio clienti eccellente. La nostra storia di successo è costruita sulla passione per l'innovazione, l'impegno per l'eccellenza e l'attenzione al cliente.</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">Il Nostro Team</h3>
                                                <p>Il nostro team è composto da esperti nel campo dello sviluppo software, intelligenza artificiale, blockchain, IoT e IT Service Management. Lavoriamo insieme per offrire soluzioni tecnicamente avanzate e su misura per i nostri clienti.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default About;